import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import { ExpansionPanel, ExpansionPanelDetails } from "@material-ui/core";
import styled from "styled-components";
import theme from "../../../assets/theme";
import MenuIcon from "@material-ui/icons/Menu";
import COLORS from "../../../assets/Colors";

const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "openSans-SemiBold, sans-serif",
    "&.MuiButton-root": {
      minWidth: "auto",
    },
    [theme.breakpoints.up(640)]: {
      "&.MuiButton-root": {
        minWidth: "64px",
      },
    },
  },
  list: {
    overflow: "auto",
  },
  fullList: {
    width: "unset",
  },
  padder: {
    paddingTop: "74px",
  },
  sidePadder: {
    paddingLeft: "2%",
    paddingRight: "5%",
    margin: 0,
    boxShadow: "none",
    borderBottom: "1px solid #e8e8e8",
  },
  listPadder: {
    padding: 0,
  },
}));

export default function TemporaryDrawer({ menuItems }) {
  const classes = useStyles();
  const [state, setState] = React.useState(false);

  const toggleDrawer = (open) => {
    setState(open);
  };

  const list = () => (
    <div
      className={clsx(classes.list, classes.fullList, classes.padder)}
      role="presentation"
      onKeyDown={() => toggleDrawer(false)}
    >
      <ExpansionPanel className={classes.sidePadder}>
        {/* <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <H2>Tabs</H2>
        </ExpansionPanelSummary> */}
        <ExpansionPanelDetails style={{ padding: 0 }}>
          <MenuList>
            {menuItems?.map((menu) => (
              <MenuItem
                style={{
                  color: menu.name === "Log Out" ? COLORS.LOGOUT_RED : "",
                }}
                onClick={() => {
                  toggleDrawer(false);
                  menu.name === "Log Out"
                    ? menu.props.onClick()
                    : window.open(menu.link);
                }}
              >
                {menu.name}
              </MenuItem>
            ))}
          </MenuList>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );

  return (
    <div style={{ display: "flex" }}>
      {
        <React.Fragment key="top">
          <Button
            className={classes.root}
            onClick={() => (state ? toggleDrawer(false) : toggleDrawer(true))}
          >
            <MenuIcon />
          </Button>
          <Drawer
            anchor={"top"}
            open={state}
            onClose={() => toggleDrawer(false)}
            style={{ zIndex: "1" }}
          >
            {list()}
          </Drawer>
        </React.Fragment>
      }
    </div>
  );
}

const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const MenuItem = styled.div`
  display: flex;
  margin: 5px 0;
  padding: 10px;
  height: 50px;
  width: 100%;
  font-family: ${theme.fonts.primaryFontSemiBold};
  cursor: pointer;
  border-bottom: 1px solid #e8e8e8;
  margin: auto 0px;
  align-items: center;
`;
